import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://latam-maestro-gemoterapia.impultienda.ar/checkout/gemo';
export const PRODUCT_NAME = 'MEGA PACK MAESTRO DE GEMOTERAPIA™';
export const PRICE = 'US$17';
export const PRICE_SHORT = 'US$17';
export const PRICE_FULL = 'US$67';
export const PAYMENT_NOTE = 'Pago único — El valor se adapta a tu moneda local';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const WHATSAPP_LINK = 'https://wa.me/541153399780';
export const INSTAGRAM_LINK = 'https://instagram.com/lumen.akasha';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.55
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-248" data-mp="1vugmmfqw4qp0">
      {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-249" data-mp="34j3i40y210ag">
          <div className="animate-aurora-1 absolute -top-16 left-[15%] h-80 w-80 rounded-full bg-brand-purpleMist blur-[100px]" data-id="element-250" data-mp="30l5u31g0sk8n" />
          <div className="animate-aurora-2 absolute -bottom-12 right-[12%] h-72 w-72 rounded-full bg-brand-goldLight/60 blur-[110px]" data-id="element-251" data-mp="2qloloc9dvs8z" />
        </div>}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
};
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  fullWidth = false,
  variant = 'purple'
}: CTAButtonProps) {
  const colors = variant === 'gold' ? 'bg-brand-goldBright text-brand-purpleDark ring-1 ring-brand-goldDark/30 hover:bg-brand-gold' : 'bg-brand-purple text-brand-goldLight ring-1 ring-brand-gold/50 hover:bg-brand-purpleDark';
  const isCheckout = href === CHECKOUT_URL;
  return <motion.a href={href} onClick={isCheckout ? trackInitiateCheckout : undefined} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold shadow-[0_10px_24px_rgba(42,18,89,.22)] transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-goldBright/50 ${colors} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-252" data-mp="1y4ynfgo6js28">
      {children}
    </motion.a>;
}